import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  error: "",
  success: "",
  profileData: "",
  user: {},
};

const ProfileSlice = createSlice({
  name: "Profile",
  initialState,
  reducers: { 
    profileSuccess(state, action) {
      state.success = action.payload.status;  // Assuming status shows success status
      state.user = action.payload.data;       // Setting user data
    },
    profileError(state, action) {
      state.error = action.payload;           // Setting error message or object
    },
    editProfileChange(state) {
      state = { ...state };                   // Shallow copy of the state, modify if deep copy needed
    },
    resetProfileFlagChange(state) {
      state.success = null;                   // Reset success flag
      state.error = "";                       // Optionally reset error as well
    },
    setProfileData(state, action) {
      state.profileData = action.payload.data || action.payload;  // Set profile data
    },
    clearProfile: (state) => {
      state.profileData = null; // Clear the profile data on logout
      state.error = null;
    },
  },
});

// Action creators
export const {
  setProfileData,
  clearProfile,
  profileSuccess,
  profileError,
  editProfileChange,
  resetProfileFlagChange
} = ProfileSlice.actions;

export default ProfileSlice.reducer;
